import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function DateSearch() {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [data, setData] = useState([]);

    const [totalFee, setTotalFee] = useState(0);
    const [loading, setLoading] = useState(false);

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const handleSearch = async () => {
        if (!fromDate || !toDate) {
            alert("Select both dates");
            return;
        }

        const url = `https://matrimony.cubixsystems.com/api/search_by_date.php?fromDate=${fromDate}&toDate=${toDate}`;

        setLoading(true); // 👈 start loading

        try {
            const res = await fetch(url);
            const result = await res.json();

            if (result.status) {
                setData(result.records || []);
                setTotalFee(result.totalFee || 0);
            } else {
                setData([]);
                setTotalFee(0);
            }
        } catch (e) {
            console.error(e);
        }

        setLoading(false); // 👈 stop loading
    };


    const [todayTotal, setTodayTotal] = useState(0);
    const fetchTodayTotal = async () => {
        try {
            const res = await fetch("https://matrimony.cubixsystems.com/api/today_total.php");
            const data = await res.json();

            if (data.status) {
                setTodayTotal(data.total || 0);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchTodayTotal();

        // 🔁 Auto refresh every 5 seconds
        const interval = setInterval(() => {
            fetchTodayTotal();
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <h3>Date Range Search</h3>

            <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
            />

            <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                style={{ marginLeft: "10px" }}
            />

            <button onClick={handleSearch} style={{ marginLeft: "10px" }}>
                Search
            </button>

            <h2>Today's Collection: ₹ {todayTotal}</h2>


            {data.length > 0 && (
                <h3 style={{ marginTop: "20px" }}>
                    Total Fee: ₹ {totalFee}
                </h3>
            )}
            {data.length > 0 && (
                <h3>Total Records: {data.length}</h3>
            )}

            {loading && <p>Loading...</p>}
            <table border="1" style={{ marginTop: "20px" }}>
                <thead>
                    <tr>
                        <th>Sl. No.</th> {/* 👈 NEW */}
                        <th>Bill No.</th>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Date</th>
                    </tr>
                </thead>

                <tbody>
                    {data.length > 0 ? (
                        data.map((row, index) => ( // 👈 add index
                            <tr key={row.id}>
                                <td>{index + 1}</td> {/* 👈 serial number */}
                                <td>{row.billNo}</td>
                                <td>{row.name}</td>
                                <td>{row.phone}</td>
                                <td>{formatDate(row.date)}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4">No data found</td> {/* 👈 updated colspan */}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}